// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.4). Shim kept
// so nothing importing the old path breaks during the transition.
// Real function declarations, not reference copies — see hooks/useAuth.ts.
import * as _module from "@livingsyncs/ui";

export function setAuthPersistence(rememberMe: boolean): void {
  return _module.setAuthPersistence(rememberMe);
}
export function restoreAuthPersistence(): void {
  return _module.restoreAuthPersistence();
}
